<template>
  <div>
    <validation-provider name="Top Content" v-slot="context">
      <b-form-group label="Top Content">
        <small v-if="context.errors.length" v-bind="context.ariaMsg" class="text-danger form-text">
          {{ context.errors[0] }}
        </small>
        <wysiwyg-editor v-model="content.top_content" />
      </b-form-group>
    </validation-provider>

    <b-form-group label="Title">
      <b-input v-model="content.title" placeholder="e.g Kategorier" />
    </b-form-group>

    <b-form-group label="Description (optional)">
      <b-input v-model="content.description" placeholder="e.g Fantastiske produkter i denne kategorien" />
    </b-form-group>

    <b-form-group label="Link Text (optional)">
      <b-input v-model="content.link_text" placeholder="e.g Se flere kategorier" />
    </b-form-group>

    <b-form-group label="Link URL (optional)">
      <b-input v-model="content.link_url" placeholder="e.g /kategori" />
    </b-form-group>

    <b-form-group label="Products">
      <multi-select
        v-model="selectedProducts"
        :options="products"
        label="name"
        track-by="id"
        value-field="id"
        :searchable="true"
        :multiple="true"
        :preserve-search="true"
        :internal-search="false"
        :clear-on-select="false"
        :close-on-select="false"
        :options-limit="30"
        :show-no-results="false"
        :hide-selected="true"
        @search-change="findProducts"
        placeholder="Choose Products"
      />
    </b-form-group>

    <validation-provider name="Bottom Content" v-slot="context">
      <b-form-group label="Bottom Content">
        <small v-if="context.errors.length" v-bind="context.ariaMsg" class="text-danger form-text">
          {{ context.errors[0] }}
        </small>
        <wysiwyg-editor v-model="content.bottom_content" />
      </b-form-group>
    </validation-provider>
  </div>
</template>

<script>
import 'vue-multiselect/dist/vue-multiselect.min.css'

import MultiSelect from 'vue-multiselect'
import WysiwygEditor from '@/components/WysiwygEditor.vue'

export default {
  name: 'PagesCustomToplistWidget',
  components: { MultiSelect, WysiwygEditor },

  props: { value: { type: Object } },

  data() {
    return {
      content: this.value,
      products: [],
      selectedProducts: this.value.products,
      resolved: {
        type: Array
      },
    }
  },

  watch: {
    selectedProducts(value) {
      this.content.products = value.map(product => {
        return {
          id: product.id,
          name: product.name,
        }
      })
    }
  },

  methods: {
    async findProducts(query) {
      await this.$store.dispatch('auth/refreshToken');
      const response = await this.$store.dispatch('products/search', query)
      this.products = response.collection?.results?.[0]?.hits || []
    },
  },
}
</script>
